// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"f1225ab9","243":"227204e1","292":"9e313f03","473":"a613f67c","488":"5d060edd","494":"d234705b","582":"07a8d518","626":"c42a77d3","721":"0245be98","990":"017fa554"}[chunkId] + ".chunk.js";
};